import { useEffect, useState } from "react";
import useApi from "./useApi";
import { getWorkflowInstanceFilterDefinitions } from "../services/workflowService";
import { WorkflowInstanceFilterDefinitionDto } from "../types/workflowDto";

/**
 * Epic 80431 - the Instances table's workflow filter options (every family the caller can filter
 * by, archived ones left out). A failure leaves only "All workflows"; useApi raises the alert.
 */
const useWorkflowInstanceFilterDefinitions = (enabled: boolean) => {
  const { executeApi } = useApi();
  const [definitions, setDefinitions] = useState<WorkflowInstanceFilterDefinitionDto[]>([]);

  useEffect(() => {
    if (!enabled) {
      setDefinitions([]);
      return undefined;
    }
    let active = true;
    executeApi<void, WorkflowInstanceFilterDefinitionDto[]>(getWorkflowInstanceFilterDefinitions, undefined).then(
      (result) => {
        if (active) setDefinitions(result ?? []);
      },
    );
    return () => {
      active = false;
    };
  }, [enabled, executeApi]);

  return definitions;
};

export default useWorkflowInstanceFilterDefinitions;
